import { SelectBox } from 'devextreme-react'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { Card, Col, Label, Row } from 'reactstrap'
import Breadcrumb from '../../components/common/breadcrumb'
import { getAllWarehouses } from '../../services/apis'
import { WAREHOUSE_PRINT_CONFIG } from '../../utils/LabelServiceV2'
import useFormatMessage from '../../utils/useFormatMessage'


const YazıcıSecimi = () => {
    const { t } = useFormatMessage()
    const [depoList, setDepoList] = useState([])
    const [depo, setDepo] = useState(null)
    const [selectedWarehouse, setSelectedWarehouse] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        fetchDepoList();
    }, [])

    const fetchDepoList = async () => {
        let swalInstance = null;
        setIsLoading(true);
        try {
            const res = await getAllWarehouses();
            if (!res) {
                throw new Error('Veri alınamadı');
            }

            let all_Data = res;

            if (res.length === 0) {
                throw new Error('Aktif depo bulunamadı');
            }
            setDepoList(res);

            const storedWarehouseId = localStorage.getItem("warehouse")
                ? parseInt(Buffer.from(localStorage.getItem("warehouse"), 'base64').toString('ascii'))
                : null;

            if (storedWarehouseId) {
                const foundWarehouse = all_Data.find(x => x.id === storedWarehouseId);
                if (foundWarehouse) {
                    setDepo(foundWarehouse.warehouse_code);
                } else {
                    // swalInstance = await showDepoSelectionSwal(all_Data, false);
                }
            } else {
                // swalInstance = await showDepoSelectionSwal(all_Data, false);
            }

            setIsLoading(false);
        } catch (err) {
            console.error(err);
            setIsLoading(false);
            toast.error(t('Depo listesi getirilirken hata oluştu'));
            // swalInstance = await showDepoSelectionSwal([], true);
        }
    };

    return (
        <>
            <Breadcrumb current={t("Yazıcı/Depo Seçimi")} />

            <Card className='p-4'>

                <Row className='m-2'>
                    <Col md="4">
                        <Label style={{ fontWeight: "600" }}>{t("Çalıştığınız Depo")}</Label>
                        <div style={{ marginTop: '8px' }}>
                            <SelectBox
                                dataSource={depoList}
                                value={depo}
                                displayExpr="warehouse_name"
                                valueExpr="warehouse_code"
                                onValueChange={(e) => {
                                    setDepo(e);
                                    if (e) {
                                        let data = depoList.find(x => x.warehouse_code === e);
                                        if (data) {
                                            localStorage.setItem("warehouse", Buffer.from(
                                                data.id.toString()).toString('base64'));
                                            localStorage.setItem("warehouseName", data.warehouse_name);

                                            // Depo seçildiğinde toast mesajı göster
                                            toast.success(`${t("Depo seçildi")}: ${data.warehouse_name}`, {
                                                position: "top-right",
                                                autoClose: 3000,
                                                hideProgressBar: false,
                                                closeOnClick: true,
                                                pauseOnHover: true,
                                                draggable: true,
                                            });
                                        }
                                    }
                                }}
                            />
                        </div>
                        {depo && (() => {
                            const selectedDepo = depoList.find(x => x.warehouse_code === depo);
                            if (selectedDepo) {
                                const hasPrinter = WAREHOUSE_PRINT_CONFIG[selectedDepo.id]?.hasPrint;

                                return (
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        marginTop: '8px',
                                        padding: '8px 12px',
                                        borderRadius: '6px',
                                        backgroundColor: hasPrinter ? '#f8fff9' : '#fff8f8',
                                        border: `1px solid ${hasPrinter ? '#d4edda' : '#f5c6cb'}`
                                    }}>
                                        <div style={{
                                            width: '12px',
                                            height: '12px',
                                            borderRadius: '50%',
                                            backgroundColor: hasPrinter ? '#28a745' : '#dc3545',
                                            border: '2px solid #fff',
                                            boxShadow: '0 0 0 1px #ccc'
                                        }}></div>
                                        <i className="fa fa-print" style={{
                                            color: hasPrinter ? '#28a745' : '#dc3545',
                                            fontSize: '14px'
                                        }}></i>
                                        <span style={{
                                            color: hasPrinter ? '#28a745' : '#dc3545',
                                            fontWeight: '500',
                                            fontSize: '13px'
                                        }}>
                                            {hasPrinter ? t("Yazıcı Mevcut") : t("Yazıcı Yok")}
                                        </span>
                                    </div>
                                );
                            }
                            return null;
                        })()}
                    </Col>
                </Row>
                {/* <Row className='m-2'>

                    <Col md="4">
                        <Label style={{ fontWeight: "600" }}>{t("Kullanılan Yazıcı Seçiniz")}&emsp;</Label>
                        <SelectBox
                            disabled
                            items={["HPLASER", "HP LASER JET PRO", "Xerox", "HDP_RIHTIM", "PRINTERTSC240", "UK_HPASA_PDI", "UK_IZMIT_PDI"]}
                        />
                    </Col>
                </Row> */}
                <hr />

                {/* <Row>
                    <div className="col-md-12 col-xs-12">
                        <a href="/yonetim" className="btn btn-app pull-left" >
                            <Button type="button" className="btn btn-light" >
                                <i className="fa fa-backward text-success"></i>&nbsp;&nbsp;
                                {t("Kaydet")}
                            </Button>
                        </a>

                    </div>
                </Row> */}

            </Card >

        </>
    )
}

export default YazıcıSecimi